var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"footer-wrap"},[_c('the-scroll-top'),_c('lazy-component',{attrs:{"margin-load":-100,"min-height":300},scopedSlots:_vm._u([{key:"default",fn:function({ isVisible }){return [(!isVisible)?_c('div'):_vm._e(),(isVisible)?_c('the-footer-dynamic'):_vm._e()]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }